/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_System_Tracks_LabelInputs */

const bn_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ট্র্যাক`)
};

const de_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPUREN`)
};

const el_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΚΟΜΜΑΤΙΑ`)
};

const en_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRACKS`)
};

const es_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PISTAS`)
};

const fr_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PISTES`)
};

const hi_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पटरियों`)
};

const hu_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PÁLYÁK`)
};

const id_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JEJAK`)
};

const it_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRACCE`)
};

const ja_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック`)
};

const ko_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트랙`)
};

const nl_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRACKS`)
};

const pl_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UTWORY`)
};

const pt_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TRILHAS`)
};

const ru_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТРЕКЫ`)
};

const sv_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SPÅR`)
};

const tr_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PARÇALAR`)
};

const uk_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТРЕКИ`)
};

const vi_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BÀI HÁT`)
};

const zh_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曲目`)
};

const zh_hant_cipher_system_tracks_label = /** @type {(inputs: Cipher_System_Tracks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`曲目`)
};

/**
* | output |
* | --- |
* | "TRACKS" |
*
* @param {Cipher_System_Tracks_LabelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_system_tracks_label = /** @type {((inputs?: Cipher_System_Tracks_LabelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_System_Tracks_LabelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_system_tracks_label(inputs)
	if (locale === "de") return de_cipher_system_tracks_label(inputs)
	if (locale === "el") return el_cipher_system_tracks_label(inputs)
	if (locale === "en") return en_cipher_system_tracks_label(inputs)
	if (locale === "es") return es_cipher_system_tracks_label(inputs)
	if (locale === "fr") return fr_cipher_system_tracks_label(inputs)
	if (locale === "hi") return hi_cipher_system_tracks_label(inputs)
	if (locale === "hu") return hu_cipher_system_tracks_label(inputs)
	if (locale === "id") return id_cipher_system_tracks_label(inputs)
	if (locale === "it") return it_cipher_system_tracks_label(inputs)
	if (locale === "ja") return ja_cipher_system_tracks_label(inputs)
	if (locale === "ko") return ko_cipher_system_tracks_label(inputs)
	if (locale === "nl") return nl_cipher_system_tracks_label(inputs)
	if (locale === "pl") return pl_cipher_system_tracks_label(inputs)
	if (locale === "pt") return pt_cipher_system_tracks_label(inputs)
	if (locale === "ru") return ru_cipher_system_tracks_label(inputs)
	if (locale === "sv") return sv_cipher_system_tracks_label(inputs)
	if (locale === "tr") return tr_cipher_system_tracks_label(inputs)
	if (locale === "uk") return uk_cipher_system_tracks_label(inputs)
	if (locale === "vi") return vi_cipher_system_tracks_label(inputs)
	if (locale === "zh") return zh_cipher_system_tracks_label(inputs)
	return zh_hant_cipher_system_tracks_label(inputs)
});